import { pick, reject, isNil } from 'ramda';

const DEFAULTS = {
  LOG_LEVEL: 'info'
};

const compactObject = reject(isNil);
const keys = Object.keys(DEFAULTS) as [Key, ...Key[]];
const filtered = pick(keys);

export type Config = typeof DEFAULTS;
export type Key = keyof Config;

export const CONFIG = {
  ...DEFAULTS,
  ...compactObject(
    typeof window !== 'undefined' ? (window.__ENV__ ?? {}) : filtered(process.env as Config)
  )
};
